var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04741 7.58172L10.0183 3.12849C10.1574 2.48301 9.99612 1.8189 9.57553 1.30686C9.15178 0.794813 8.52566 0.5 7.85525 0.5H5.53407C2.48243 0.5 0 2.93609 0 5.93077V16.0692C0 19.0639 2.48243 21.5 5.53407 21.5H7.85525C8.52566 21.5 9.15494 21.2052 9.57553 20.6931C9.99928 20.1811 10.1606 19.517 10.0183 18.8715L9.04741 14.4183L5.53407 13.7293V8.27065L9.04741 7.58172Z",
    fill: "#EF0074"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0228 1.94925H15.7516C15.8369 2.07649 15.9223 2.19752 16.0077 2.32165C16.1816 2.59163 16.3619 2.85541 16.5232 3.13471C19.4451 7.86724 19.5527 13.6394 16.7667 18.4588C16.7097 18.5612 16.5896 18.7598 16.5232 18.8684C16.3619 19.1446 16.1816 19.4115 16.0077 19.6815C15.9223 19.8056 15.8369 19.9266 15.7516 20.0539H17.026C17.1873 19.9142 17.3485 19.7684 17.4972 19.6163C17.6015 19.5077 17.7628 19.3587 17.864 19.2408C22.3482 14.3842 21.9845 6.27835 17.0228 1.94925Z",
    fill: "#EF0074"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6359 4.84772H12.605C12.8675 5.34425 13.1299 5.83767 13.3545 6.34661C14.768 9.45301 14.6827 12.9815 13.1774 16.0413C12.9971 16.4168 12.8011 16.783 12.605 17.1554H13.6454C17.5635 14.2104 17.5445 7.74309 13.6359 4.84772Z",
    fill: "#EF0074"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallFooter);
export default __webpack_public_path__ + "static/media/call_footer.3ef39b176ab882dcaa4d422e94a5968a.svg";
export { ForwardRef as ReactComponent };